module.exports = __webpack_public_path__ + "static/media/merel.e3af6535.png";